import {
  MessengerMessageTemplateDraft,
  MessengerMessageTemplateHeader,
  MessengerMessageTemplateHeaderType,
  MessengerMessageTemplateSingleHeader,
} from 'shared/api/requests/messenger/schemas'

export const isHeaderWithAttachment = (
  header: MessengerMessageTemplateHeader,
): header is MessengerMessageTemplateSingleHeader => {
  return Boolean(!Array.isArray(header) && header?.type)
}

export const checkIfHeaderIsValid = (header: MessengerMessageTemplateDraft['header']): boolean => {
  const isSingleHeader = header && !Array.isArray(header)

  if (!header || (Array.isArray(header) && header.length === 0)) {
    return true
  }
  if (isSingleHeader && header.type === MessengerMessageTemplateHeaderType.TEXT) {
    return true
  }
  const isHeaderTextValid =
    isSingleHeader &&
    header.type === MessengerMessageTemplateHeaderType.IMAGE &&
    ((Boolean(header.text) && Boolean(header.url)) ||
      (Boolean(header.text) && !header.url) ||
      (!header.text && !header.url))
  return Boolean(isHeaderTextValid)
}
